import { HubOptionStateValue } from 'dorian-shared/types/branch/HubOption';
import type { ReplayCondition } from 'dorian-shared/types/branch/HubOption';

export function isReplayConditionValid(c: ReplayCondition): boolean {
  const subsValid = c.subConditions.length > 0 && c.subConditions.every((sub) => {
    if (sub.variableId == null) return false;
    const hasInt = sub.intValue !== undefined && sub.intValue !== '';
    const hasVar = sub.varValue !== undefined && sub.varValue !== null && sub.varValue !== 0;
    return hasInt || hasVar;
  });
  if (!subsValid) return false;
  if (c.resultState == null) return false;
  if (c.resultState === HubOptionStateValue.Active && c.resultGotoBranchId == null) return false;
  return true;
}
